import React from 'react'
import assets from '../assets'
import Button from '../Components/Button'
import Datablock from '../Components/Datablock'
import './index.css'
import { motion } from 'framer-motion'

const Section4 = ({handleActivePopUp, variants}) => {
  return (
    <div className='section deflautility relative'>
        <img className='lightSection' src={assets.light.hero1} alt="Light" />
        <img className='lightSection2' src={assets.light.hero1} alt="Light" />
        <div className="container-lg flex flexRow alignCenter relative cols justifySpace flexWrap gap">
            {/* Row 1 */}
            {/* Col 1 */}
            <motion.div
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .3 }}
            viewport={{ once: true }}
            className="flex flexCol order1">
                <h2>Deflation</h2>
                <p>
                    The most important lesson central banks taugh us through history is that <strong>inflation hurts..</strong> 
                </p>
                <p>
                    We burn all gas plus a safe fraction in treasury. <strong>90% of circulating suply will be burned</strong> day by day until matching 21,000,000 final tokens from original 210,000,000.
                </p>
            </motion.div>
            {/* Col 2 */}
            <motion.div
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .5 }}
            viewport={{ once: true }}
            className="iconCorner dataDiv flex flexCol order2">
                <Datablock number={'90'} type={'%'} span={'Of circulating supply to be burnt'}/>
                <Datablock number={'100'} type={'%'} span={'Of All Gas is burned'}/>
            </motion.div>
            
            {/* Row 2 */}
            {/* Col 1 */}
            <motion.div
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .7 }}
            viewport={{ once: true }}
            className='order3 flex alignCenter justifyCenter'
            >
                {assets.icons.utility}
            </motion.div>
            {/* Col 2 */}
            <motion.div
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .9 }}
            viewport={{ once: true }}
            className="flex flexCol order4">
                <h2>Utility</h2>
                <p>
                    The ECON token functions as a utility tool to concentrate all synthetic assets value.
                </p>
                <p>
                    All  rewards are generated from treasury and ecosystem performance, NOT by minting inflation as traditional protocols.
                </p>
            </motion.div>
        </div>
        <div className="container-lg flex flexCol alignCenter">
            <Button link={'#contact'} text={'Apply White List Pre-Sale'} handleActivePopUp={handleActivePopUp} popData='white'/>
            {assets.arrowDown}
        </div>
    </div>
  )
}

export default Section4